document.addEventListener('alpine:init', () => {
function ProgressiveBar(cart){          
          var thsld = $('.cart-progress-bar').data('throshold');
          var pprr = cart.items_subtotal_price;

          if(thsld > pprr){
            var leftItem = pprr / 100;
            var finalRemain = leftItem * 100;
            var remainss = 5500 - pprr;
            var leftItem = pprr / 100;
            var finalRemain = leftItem * 100;
            var remainss = 5500 - pprr;
            var remainss1 = 8500 - pprr;
            var main_remain=remainss /100;
            
            if(leftItem <= 10){
              var minuss = leftItem - 2;
            }
            else if(leftItem <= 20 && leftItem > 10){
              var minuss = leftItem - 5;
            }
            else if(leftItem <= 30 && leftItem > 20){
              var minuss = leftItem - 7;
            }
            else if(leftItem <= 40 && leftItem > 30){
              var minuss = leftItem - 9;
            }
            else if(leftItem <= 55 && leftItem > 40){
              var minuss = leftItem -2 +2;
            }
              else if(leftItem <= 65 && leftItem > 55){
              var minuss = leftItem -5 +6;
            }
              else if(leftItem <= 75 && leftItem > 65){
              var minuss = leftItem -3;
            }
                 else if(leftItem <= 80 && leftItem > 75){
              var minuss = leftItem - 2;
            }
              else if(leftItem <= 85 && leftItem > 80){
              var minuss = leftItem - 1;
            }
           else if(leftItem > 85){
              var minuss = leftItem+10;
            }
            $('.cart__bar .cart__progress').css('width',(minuss)+'%');
            if(pprr <= 5500){
              
            $('.cart__shipping-text .completionWording').html('Plus que <span class="remianing-price"> '+main_remain+'€ </span>pour la livraison gratuite').css('color','#000');

            }else if(pprr < thsld && pprr > 5500){
             
              $('.cart__shipping-text p').html("Bravo ! La livraison est offerte").css('color','green').addClass('cart__shipping-text-new-custom');

            }
             else{

         $('.cart__bar .cart__progress').css('width','100%');
            $('.cart__shipping-text p').html("Excellent choix !").css('color','green');
          }
            
          }
          else{
      
         $('.cart__bar .cart__progress').css('width','100%');
            $('.cart__shipping-text p').html("Excellent choix !").css('color','green');
          }
          
          
        }
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
              setTimeout(function(){
                console.log(cart.items_subtotal_price)
               $.getJSON( "/cart.json", function( cart ) {
               ProgressiveBar(cart);
             });
                }, 1000);
              
            }
          );

        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});
